import { JSX, useMemo } from 'react';
import sanitize from 'sanitize-html';
import { twMerge } from '../../utils/tw-merge';

interface RichTextProps {
    text: string;
    className?: string;
    as?: keyof JSX.IntrinsicElements;
}

function RichText({ text, className, as: Tag = 'div' }: RichTextProps): JSX.Element {
    const richTextClasses = twMerge('prose md:prose-lg max-w-none mb-0', className);
    const sanitizedHtml = useMemo(() => sanitize(text), [text]);

    return <Tag className={richTextClasses} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
}

export default RichText;
